import { MLanguage } from 'vue-multilanguage';

export default new MLanguage('en').create({
    // Header
    safeEnvironment: 'Environment',
    safeEnvironmentSuffix: ' 100% Safe',

    //Footer
    developedBy: 'Developed by',
    securePayment: 'Secure payment',

    // Link Info
    linkInfo: 'Sent a payment request',

    // Total Overview
    totalAmount: 'Total amount',
    delivery: 'Delivery',
    deliveryAddress: 'Delivery address',
    payment: 'Payment',
    paymentDate: 'Payment date',

    // Card Overview
    purchaseSummary: 'Purchase Summary',
    productOrServiceDescription: 'Product or service description',
    showDescription: 'Show description',
    hideDescription: 'Hide description',

    // Cart Items
    more: 'more',
    showLess: 'show less',
    seeAllItems: 'See all items',
    hideItems: 'Hide items',

    // Shipping Method Overview
    within2Hours: 'Within 2 Hours',
    withinOneBusinessDay: 'Within 1 Business Day',
    withinAnyBusinessDays: 'Within {0} Business Days',
    free: 'Free',

    // Common
    of: 'of',
    off: 'off',
    cartDiscount: 'Cart discount',
    discountOn: 'Discount on',
    zipcode: 'Zipcode',
    street: 'Street',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2 (Optional)',
    number: 'Number',
    complement: 'Complement',
    district: 'District',
    city: 'City',
    state: 'State',
    province: 'Province',
    cpf: 'CPF',
    cnpj: 'CNPJ',
    foreign: 'Foreign',
    foreigner: 'State, province, district (acronym)',
    continue: 'Continue',
    confirmPayment: 'Confirm payment',
    back: 'Back',
    cancel: 'Cancel',
    thanks: 'Thanks!',
    notAvailable: 'Not available',
    copyCode: 'Copy code',
    retry: 'Retry',
    copied: 'Copied',
    identityConfirmation: 'Identity confirmation',
    confirmIdentity: 'Confirm identity',

    // Address
    chooseYourState: 'Choose your state',
    chooseYourProvince: 'Choose your province',
    forgotIt: 'I forgot it',

    // Shipping Type
    selectDeliveryType: 'Select a delivery option',
    shippingAddressInfo: 'Enter delivery address',
    freight: 'Freight',
    freightDefined: 'Freight defined',

    // Change Payment Type
    chooseHowYouWantToPay: 'Choose how you want to pay',
    orChooseOtherWays: 'or choose other ways',
    otherPaymentMethods: 'Other payment methods',
    expressPayment: 'Express card payment',

    // Personal Data
    personalDataSubtitle: 'Almost done! Fill the form below to continue',
    fullName: 'Full name',
    email: 'E-mail',
    cellPhone: 'Cell Phone',
    identity: 'Document number',
    identityC2P: 'Document number',
    billingAddress: 'Billing address',
    termsPreffix: 'I have read and accept the',
    termsSuffix: ' terms and conditions of use',
    privacyPreffix: `I want to receive promotions from Cielo's business partners. More details`,
    privacySuffix: ' Privacy Policy',
    completePurchase: 'Complete purchase',
    sameAddressOption: 'My billing address is the same as shipping',

    // Billing Address
    nationalAddress: 'National address',
    internationalAddress: 'International address',
    national: 'National',
    international: 'International',

    // Card Payment
    paymentByCreditCard: 'Payment by credit card',
    paymentByDebitCard: 'Payment by debit card',
    paymentByVoucherCard: 'Payment by voucher',
    paymentByMultibenefits: 'Payment by Multi-benefit card',
    paymentByGooglePay: 'Payment by Google Pay',
    cardName: 'Name',
    expiration: 'Expiration',
    securityCode: 'Security code',
    cardNameHolder: 'Holder\'s name (as shown on card)',
    cardNameHolderValidation: 'Holder\'s name',
    cardNumber: 'Card number',

    // Payment Success
    paymentSuccessTitle: 'Your order has been successfully placed!',
    paymentSuccessDetail:
		'Thank you for shopping with {0}, a partner of Cielo! You can track the status of your payment on our ',
    paymentSuccessButtonLabel: 'Check Orders page',

    // Loggi Message
    loggiThanksMessage: 'Thanks for buying with us ',
    loggiSuccessTitle:
		'Your order has been placed and we are confirming the payment.',
    loggiSuccessBody:
		'Soon you will receive an SMS from Loggi, to track your order. And all your purchase information was sent in your email:',
    requestNumber: 'Request number',

    // Boleto Message
    boletoSuccessBody:
		'To finalize your purchase, make the boleto payment. Payment will be approved within 1 or 2 business days.',
    barcode: 'Barcode',
    openBoleto: 'Open boleto',

    // Pix Finalize
    pixSuccessBody:
		'To complete your purchase make the Pix payment. The payment will be approved on the spot!',
    qrcodeExplanation:
		'You can also pay via QRCode. Just scan from another mobile device',
    paywithPixSuccessFooter: 'Pay with',
    advertisingPixSuccessFooter: 'Available on Google Play and Apple Store',

    // Payment Methods
    creditCard: 'Credit card',
    creditCardText: 'Enter the card details',
    debitCard: 'Debit card',
    debitCardText: 'Enter the card details',
    boleto: 'Boleto',
    pix: 'Pix',
    pixText: 'Pay instantly',
    qrCodePay: 'Qr Code Credit',
    qrCodePayText: 'Scan the QR Code',
    voucher: 'Voucher',
    qrCodeDebit: 'Qr Code Debit',
    qrCodeDebitText: 'Scan the QR Code',
    clickToPay: 'ClickToPay',
    multibenefits: 'Multi-benefit Card',
    multibenefits2: 'Food and Meal',
    googlePay: 'Google Pay',
    applePay: 'Apple Pay',
    pixOpenFiance: 'Pix by Open Finance',
    paymentByPixOpenFinance: 'Payment by Pix Open Finance',
    pixTypePixText: 'Scan or copy the code',
    pixTypeOpenFinanceText: 'Pay with your bank',
    recommendedBadge: 'Recommended',

    // Card Installments
    chooseInstallmentsNumber: 'Choose an installments number',
    installmentsNumber: 'Installments number',
    installmentsItem: '{quantity}x of R$ {installmentPrice} (no fees)',
    installment: 'Installment',
    installmentSupportText: 'Please provide the card number to check the installment amount',

    // Popups
    addressSearchZipcode: 'Wait, we are consulting your zip code',
    addressZipcodeNotFound:
		'We did not find the address information based on this zip code, continue filling in the fields',
    addressUnderstood: 'I understood',
    warning: 'Warning',
    paymentProviderPurchaseError: 'There was an error processing your purchase',
    wait: 'Wait',
    unexpectedError: 'There was an unexpected error!',
    withoutMessage: 'Without message',
    qrCodeGenerationError:
		'There was an error generating the qrcode for your transaction. Please open the link again and repeat the payment process.',
    finalizingPaymentError: 'Finalizing payment error',
    unknownPaymentError: 'Unknown error when finalizing payment',
    chooseYourState: 'Please, choose your state.',
    unableCalculateShippingCost:
		'Unfortunately we were unable to calculate the shipping cost.',
    invalidExpirationDate: 'Invalid expiration date',
    processingRequestError: 'Processing request error',
    cardBrandNotSupported: 'Card brand not supported',
    applePayErrorTitle: 'Error processing payment with Apple Pay',
    applePaySesssionError: 'Error creating Apple Pay session. Please select another payment method or contact the store.',
    applePayContactFieldError: 'Please check if all personal and billing address details are correctly registered on your iOS device and try again.',
    applePayCompletePaymentError: 'Error completing payment with Apple Pay. Please select another payment method or contact the store.',
    applePayBillingContactError: 'Please check if all the card\'s billing address details are correctly registered on your iOS device and try again.',
    applePayShippingContactError: 'Please check if all personal details are correctly registered on your iOS device and try again.',

    // message codes
    cardExpired: 'Card Validity Expired. Please, select another card',
    couldNotCalculateFreight:
		'Could Not Calculate Freight. Please, informe your Zip Code for shipping again.',
    fillWithFullName: 'Please, Fill With Full Name',
    finalizePaymentError:
		'The request could not be finalized. Please contact the store.',
    indentifyInvalid: 'CPF/CNPJ invalid. Try again.',
    internationalBillingAddressIsNotEnabled:
		'International billing data can not be sent',
    invalidCardNumber: 'Invalid Card Number. Try other card.',
    invalidCheckoutCieloCard:
		'Elo card entered is not the credit card valid to Cielo Checkout purchase.',
    invalidCvv: 'Invalid Cvv code. Please, try again.',
    invalidFlagForCardNumber:
		'The selected brand is not valid for the provided card number.',
    invalidFormZipcodeMandatory:
		'Formulário inválido. CEP de preenchimento obrigatório',
    orderAlreadyProcessedMessage: 'Your order is already being processed',
    pleaseInformHolder: 'Please, Inform Card Holder\'s Name',
    productRemovedOrNotFound:
		'The requested product was not found or is no longer available.',
    wrongOperationResultSafetyCheck:
		'Operation result is wrong (security check)',
    openFinanceUrlIsNull: 'Please try again.',
    tryCreateNewLink: 'Please contact the store to generate a new payment link.',

    // title message codes
    opsTitle: 'Oppsss!',
    openFinanceUrlIsNullTitle: 'Error redirecting to the bank',

    // mpi
    cardAuthenticationError:
		'An authentication error has occurred. Please select another card or payment method.',
    notAuthenticableCardError:
		'Card not authenticated. Please select another card or payment method.',
    unexpectedAuthenticationError:
		'An unexpected authentication error has occurred. Please try again or select another payment method.',
    flagDoesNotSupport:
		'Flag does not support authentication. Please select another card or payment method.',

    // qr code  pay
    qrCodePayTitle: 'QR Code Payment',
    payWithQrCodeSuccessFooter: 'Pay with',
    mobileAppAvailable: 'Available on Google Play and Apple Store',
    qrCodePayExplanation:
		'To complete your purchase make the payment by scanning the QR Code below. Just scan from another mobile device.',

    // Order response overview
    customerName: 'Name',
    orderNumber: 'Order number',
    documentNumber: 'Document',
    orderDate: 'Order date',

    //ClickToPay Infos
    clickToPayText: 'Faster purchases with your credit card.',
    clickToPayCTAText: 'About Click to Pay',
    clickToPayIdentityInfo:
		'The information will be used by Click to Pay to validate your identity.',
    clickToPayLegalPersonInfo:
		'Click to Pay is not available to legal entities. If this is your case, ',
    clickToPayChangePaymentMethodCTA: 'change your payment method here.',

    clickToPayModalTitle: 'Click to Pay',
    clickToPayModalDescriptionFlags:
		'A fast and secure payment method, compatible with Mastercard and Visa',
    clickToPayModalDescriptionProtectedInf: 'Keep your information secure',
    clickToPayModalDescriptionUseWorld: 'Use in stores worldwide',
    clickToPayModalDescriptionSimplePayment:
		'Set up once and make hassle-free payments in the future',

    clickToPayNewCardFormHeader: 'Credit card details',

    clickToPayAllowCheckout1: 'Register my information with ',
    clickToPayAllowCheckout2: ' on Click To Pay for faster and safer purchases.',

    clickToPayRememberMe: 'Remember my cards in this browser.',
    clickToPayAgreementText1: 'By continuing, you agree to the',

    clickToPayAgreementTerms: 'Terms ',

    clickToPayAgreementText2: 'and understand that your data will be treated in accordance with the',
    clickToPayAgreementPrivacyTerms: 'Privacy standards.',
    clickToPayAllowSaveCard: 'Save my card in Click to Pay for fast and secure purchases.',
    clickToPaySaveYourCard: 'Save your card',
    clickToPayWithSavedCard: 'Pay with a saved card',

    otpTitle: 'Access your cards',
    otpDescriptionInsertCode: 'Enter the authentication code sent by',
    otpDescriptionToEmail: 'to email',
    otpWrongEmail: 'Is the email wrong?',
    otpResendCode: 'Resend code',
    otpRememberMe: 'Remember my cards in this browser',
    otpInvalidCodeError: 'Invalid code. Please resend the code or try again',
    otpInaccessibleError:
		'The account is currently unavailable. Try again later',
    otpRetriesExceededError:
		'The number of retries has been exceeded. Try again later',
    otpUnknownError: 'Unable to access this account. Try again later',

    // ClickToPay Redesign
    paymentWithC2P: 'Payment with Click to Pay',
    accessYourSavedCards: 'Access your saved cards',
    howC2PUses: 'How does Click to Pay use my information?',
    howC2PUsesTooltipText: 'Click to Pay will use your phone number and email to check if there are saved cards. A code may be sent to your phone to verify your identity. Text message charges may apply.',
    addCard: 'Add card',
    rememberCards: 'Remember cards in this browser',
    rememberCardsTooltipText1: 'With the card saved in the browser, you will not go through verification and will be able to access your cards quickly and securely in Click to Pay.',
    rememberCardsTooltipText2: 'Not recommended to save on public or shared devices.',
    edit: 'Edit',
    c2pAgreementText: 'By continuing, you accept the registration of your card with Click to Pay.',
    c2pAgreementTerms: 'Terms and conditions of ',
    and: 'and',
    c2pCardVerifying: 'Click To Pay is checking for saved cards',
    finishPaymentTitle: 'Almost there! Enter your document number before finishing',
    yourPersonalData: 'Your personal data',


    // Checkout errors
    errorCheckoutHeading: 'Could not continue with this card',
    errorCheckoutBody: 'Choose another card or change the payment method',

    //Contact view
    contactTitle: 'Contact details',
    chooseCountry: 'Choose country',
    selectCountry: 'Select',
    errorOTPHeading: 'Error validating data',
    errorOTPBody: 'Choose another payment method or try again.',
    errorOTPCTA: 'Ok, I got it',

    //Personal view
    PersonalTitle: 'Personal data',

    //Card list view
    cardListTitle: 'Cards saved in Click to Pay',
    enterYourDocument: 'Enter your document',
    chooseTheNumberOfInstallments: 'Choose the number of installments',
    chooseInstallmentsNumberV2: 'Number of installments',
    areTheCardsNotYours: 'Are the cards not yours?',
    showAllCards: 'Show all cards',
    hideCardList: 'Hide card list',
    addNewCard: 'Add new card',
    locked: '(Locked)',
    expired: '(Expired)',
    lockedAndExpired: '(Locked) (Expired)',
    thisCardIsLocked: 'This card is locked.',
    thisCardIsExpired: 'This card is expired.',
    thisCardIsLockedAndExpired: 'This card is locked and expired',

    //Order status, invalid url and invalid order views
    orderStatus: 'Order status',
    invalidUrlTitle: 'The page you are looking for does not exist',
    invalidUrlText: 'Check the spelling and try again.',
    invalidOrderTitle: 'Service temporarily unavailable',
    invalidOrderText: 'Unfortunately, it will not be possible to proceed at the moment. Please try again later.',
    update: 'Update',
    paymentUnderReview: 'Payment under review',
    paymentUnderReviewText1: 'Payment confirmation is done after approval from {0}.',
    paymentUnderReviewText2: 'Track the payment status on our ',
    paymentDenied: 'Payment denied',
    paymentDeniedText: 'Check the card details or try again using another payment method.',
    paymentApproved: 'Payment approved',
    paymentApprovedText: 'You paid {0}.',
    paymentSummary: 'Payment summary',
    paymentDate: 'Payment date',
    paymentRefused: 'Payment refused',
    idPayConfirmation: 'To ensure the security of your purchase, we need confirmation of the identity of the person holding the card used for the purchase, within 1 hour.',
    confirmationInProgress: 'Confirmation in progress',
    idPayRedirectText: 'Please wait a few seconds while we process the identity confirmation.',
    openFinanceRedirectError: 'An error occurred',
    openFinanceRedirectErrorText: 'We could not redirect you to the bank, but you can try to make the payment again later.',
    changePaymentType: 'Change payment method',
    openFinanceInterrupted: 'It was not possible to make the Pix via Open Finance',
    openFinanceInterruptedText: 'The transaction was interrupted. You can select another bank, change the payment method, or try again later.',
    openFinanceWrongData: 'Your identification data is incorrect',
    openFinanceWrongDataText: 'Check your personal data to confirm the transaction or change the payment method.',
    openFinanceWaitingConfirm: 'Wait for the payment confirmation from your bank within 30 minutes.',
    openFinanceCancel: 'I want to cancel the payment',
    openFinanceCancelModalTitle: 'Payment cancellation',
    openFinanceCancelModalText: 'Are you sure you want to cancel the payment? This action cannot be undone.',
    openFinanceCancelModalConfirm: 'Yes, cancel',
    paymentCanceled: 'Payment canceled',
    paymentCanceledText: 'Your payment was successfully canceled and no amount will be debited from your account.',
    employerNumber: 'CNPJ da loja',
    transactionId: 'Transaction ID',

    //Pix Type View
    changePixTypeTitle: 'Pix payment options',
    changePixTypeOpenFinanceInfo1: 'With Pix via Open Finance, your payments will be fast and secure!',
    changePixTypeOpenFinanceInfo2: 'You will no longer need to leave the checkout to go to the bank to pay.',
    pixTypeFilterBank: 'Which bank do you want to pay from?',
    pixTypeSuggestions: 'All banks',
    pixTypeEmptySearchTitle: 'Bank not found',
    pixTypeEmptySearch: 'Make sure the bank name is spelled correctly, otherwise it may not be part of the Open Finance initiative.',
    pixOFOrderReviewTitle: 'Selected bank',
    pixOFOrderReviewRedirectWarning1: 'To complete, we will redirect you to ',
    pixOFOrderReviewRedirectWarning2: ', you need to have balance there.',
    pixOpenFinanceRedirect: 'Payment authorization',
    pixOpenFinanceRedirectLoading1: 'We are completing your payment at Cielo',
    pixOpenFinanceRedirectLoading2: 'Please wait a few moments',
    pixOpenFinanceSecurityRedirect: 'This redirection is done securely via Open Finance.',
    pixOpenFinancePayToday: 'Pay today',
    pixOpenFinanceLoadingBanks: 'Loading banks',
    pixOpenFinanceGoNowToBank: 'Go now to',

    //CVVAlert
    securityCVV: 'For security reasons, please enter your CVV',
    send: 'Send',

    //v2

    inputCVV: 'CVV',
    inputCardHolderName: 'Name as it appears on the card',
    inputCardDueDate: 'Card expiry',
    titleViewCredCard: 'Payment by credit card',
    titleViewDebitCard: 'Payment by debit card',
    titleViewQrCodeCred: 'Payment by credit QR Code',
    titleViewMultibenefitsCard: 'Food and Meal',
    titleViewGooglePay: 'Payment by Google Pay',
    titleViewApplePay: 'Payment by Apple Pay',
    textViewMultibenefitsCard: 'Use with Multi-benefit',
    installmentsExplanationV2: 'Choose the number of installments',
    qrcodeExplanationV2: 'You can also pay via QRCode. Just scan from another cell phone',
    whatPayment: 'How do you want to pay?',
    orderReview: 'Order review',
    pixDescription: 'You can also pay via QRCode',
    qrcodeTitle: 'To complete your payment, scan the QR Code below',
    qrcodeInstruction: 'Open the QR Code acceptance link (digital wallets) in a new browser tab:',
    textInstructionPayment: 'Instructions for making payment',
    textInstructionPayment2: 'Use digital wallets for payment:',
    numberCardError: 'Invalid card number',
    dateMonthCardError: 'Invalid month. It must be between 1 and 12.',
    cardExpirationError: 'The due date must be in the future.',
    new: 'New',
    yourDocumentNumber: 'Your document number',

    // Select Phone
    countryCode: 'Select country code',
    selectCountryCode: 'Country code',

	 // Select Document Type
	 documentType: 'Select the type of document',
	 selectDocumentType: 'Choose Type of document',

	 // Select Country
	 country: 'Select the country',
	 selectCountry: 'country',
    wrongFlowMultibenefitsError: 'This seems to be a food and meal card. Please provide the credit card details.',
    verifyCardMultibenefitsError: 'Check the number of your card, make sure it\'s an Elo food and meal card',
    finishButtonQrCode: 'Generate QR Code',
    finishButtonPix: 'Generate Pix code',
    change: 'Change',
    changePayment: 'Change payment',

    //Accessibility
    altLogo: 'Cielo\'s logo, with the letters C-I-E-L-O stylized in gray and blue on a white background.',
    altLangEn: 'Flag of the United Kingdom, English language.',
    altLangEs: 'Flag of Spain, Spanish language',
    altLangBr: 'Flag of Brazil, Portuguese language.',
    altPix: 'Image of the Pix QR Code for scanning.',
    altQrCode: 'Image of the QR Code for scanning.',
    ariaLangList: 'Language selection list.',
    ariaShippingTypeList: 'Shipping type selection list.',
    ariaPaymentTypeList: 'Payment type selection list.',
    ariaSelectList: 'selection list of :',
    ariaOrderSummary: 'Order summary.',
    ariaSeeAllItems: 'Click to display all items in the order.',
    ariaShowDescription: 'Click to expand the description.',
    ariaShowOrderSummaryContent: 'Click to expand the order summary.',
    ariaCTANull: 'Disabled button.',
    ariaCTAC2P: 'Click to select the payment method Click to Pay.',
    ariaCTAAboutC2P: 'Click to learn more about Click to Pay.',
    ariaCTACloseOverlay: 'Click to close the overlay.',
    ariaCTASelect: 'Click to open the selector of :',

});
